export default __webpack_public_path__ + "static/media/loginbj.b1a064a2.png";